/**
 * Vista: Lista de Órdenes de Compra
 *
 * Módulo para gestionar el flujo de órdenes de compra:
 * - Listar órdenes de compra
 * - Crear desde requisición aprobada
 * - Ver detalle
 * - Confirmar/Cancelar
 */

import router from '../router/router.js';
import modal from '../utils/modal.js';

export default {
  async render() {
    return `
      <div class="card">
        <div class="card-header">
          <h2 class="card-title">📄 Órdenes de Compra</h2>
          <div>
            <button class="btn btn-primary" onclick="window.ordenesCompraView.mostrarModalCrear()">
              ➕ Nueva Orden
            </button>
          </div>
        </div>

        <!-- Estadísticas -->
        <div id="statsContainer" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="stat-card" style="background: #fff3cd; padding: 1rem; border-radius: 8px; text-align: center;">
            <div id="statEmitida" style="font-size: 2rem; font-weight: bold;">0</div>
            <div style="color: #856404;">Emitida</div>
          </div>
          <div class="stat-card" style="background: #d4edda; padding: 1rem; border-radius: 8px; text-align: center;">
            <div id="statConfirmada" style="font-size: 2rem; font-weight: bold;">0</div>
            <div style="color: #155724;">Confirmada</div>
          </div>
          <div class="stat-card" style="background: #cce5ff; padding: 1rem; border-radius: 8px; text-align: center;">
            <div id="statEnTransito" style="font-size: 2rem; font-weight: bold;">0</div>
            <div style="color: #004085;">En Tránsito</div>
          </div>
          <div class="stat-card" style="background: #d1ecf1; padding: 1rem; border-radius: 8px; text-align: center;">
            <div id="statRecibida" style="font-size: 2rem; font-weight: bold;">0</div>
            <div style="color: #0c5460;">Recibida</div>
          </div>
        </div>

        <!-- Filtros -->
        <div class="filters" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="form-group">
            <label class="form-label">Estado</label>
            <select id="filtroEstado" class="form-select">
              <option value="">Todos</option>
              <option value="emitida">Emitida</option>
              <option value="confirmada">Confirmada</option>
              <option value="en_transito">En Tránsito</option>
              <option value="recibida">Recibida</option>
              <option value="cancelada">Cancelada</option>
            </select>
          </div>
          <div class="form-group">
            <label class="form-label">Proveedor</label>
            <select id="filtroProveedor" class="form-select">
              <option value="">Todos</option>
            </select>
          </div>
          <div class="form-group">
            <label class="form-label">Buscar</label>
            <input type="text" id="filtroBusqueda" class="form-input" placeholder="Folio OC..." />
          </div>
          <div class="form-group" style="display: flex; align-items: flex-end;">
            <button class="btn btn-secondary" onclick="window.ordenesCompraView.cargarOrdenes()" style="width: 100%;">
              🔍 Filtrar
            </button>
          </div>
        </div>

        <!-- Tabla -->
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Folio</th>
                <th class="tbl-hide-mobile">Fecha</th>
                <th class="tbl-hide-mobile">Proveedor</th>
                <th class="tbl-hide-mobile">Requisición</th>
                <th class="tbl-hide-mobile">Items</th>
                <th class="tbl-hide-mobile">Total</th>
                <th class="tbl-hide-mobile">Estado</th>
                <th class="tbl-hide-mobile">Acciones</th>
              </tr>
            </thead>
            <tbody id="ordenesTableBody">
              <tr>
                <td colspan="9" style="text-align: center; padding: 2rem;">
                  Cargando órdenes de compra...
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginación -->
        <div id="pagination" class="pagination" style="display: flex; justify-content: center; gap: 0.5rem; margin-top: 1rem;"></div>
      </div>

      <!-- Modal Crear Orden de Compra desde Requisición -->
      <div id="modalCrearOC" class="modal" style="display: none;">
        <div class="modal-content" style="max-width: 900px;">
          <div class="modal-header">
            <h3>Nueva Orden de Compra</h3>
            <button class="modal-close" onclick="window.ordenesCompraView.cerrarModal()">&times;</button>
          </div>
          <div class="modal-body">
            <!-- Paso 1: Seleccionar Requisición -->
            <div id="paso1" class="paso-form">
              <h4 style="margin-bottom: 1rem;">Paso 1: Seleccionar Requisición Aprobada</h4>
              <div class="form-group">
                <label class="form-label">Requisiciones Aprobadas</label>
                <select id="requisicionSelect" class="form-select" style="font-size: 1rem;">
                  <option value="">Seleccione una requisición...</option>
                </select>
              </div>
              <div id="requisicionDetalle" style="display: none; margin-top: 1rem; padding: 1rem; background: #f9f9f9; border-radius: 8px;">
                <!-- Detalle de requisición seleccionada -->
              </div>
            </div>

            <!-- Paso 2: Datos del Proveedor y Condiciones -->
            <div id="paso2" class="paso-form" style="display: none;">
              <h4 style="margin-bottom: 1rem;">Paso 2: Proveedor y Condiciones</h4>
              <div class="oc-form-grid">
                <div class="form-group">
                  <label class="form-label required">Proveedor</label>
                  <select id="proveedorSelect" class="form-select" required>
                    <option value="">Seleccione proveedor...</option>
                  </select>
                </div>
                <div class="form-group">
                  <label class="form-label">Moneda</label>
                  <select id="moneda" class="form-select">
                    <option value="USD">USD - Dólar</option>
                    <option value="MXN">MXN - Peso Mexicano</option>
                  </select>
                </div>
                <div class="form-group">
                  <label class="form-label">Fecha Entrega Esperada</label>
                  <input type="date" id="fechaEntrega" class="form-input" />
                </div>
                <div class="form-group">
                  <label class="form-label">Lugar de Entrega (Almacén)</label>
                  <select id="almacenSelect" class="form-select">
                    <option value="">Seleccione almacén...</option>
                  </select>
                </div>
                <div class="form-group">
                  <label class="form-label">Condiciones de Pago</label>
                  <select id="condicionesPago" class="form-select">
                    <option value="contado">Contado</option>
                    <option value="credito_30">Crédito 30 días</option>
                    <option value="credito_60">Crédito 60 días</option>
                    <option value="credito_90">Crédito 90 días</option>
                    <option value="anticipo_50">50% Anticipo, 50% Entrega</option>
                  </select>
                </div>
              </div>
              <div class="form-group" style="margin-top: 1rem;">
                <label class="form-label">Observaciones</label>
                <textarea id="observaciones" class="form-textarea" rows="3" placeholder="Notas adicionales..."></textarea>
              </div>
            </div>

            <!-- Paso 3: Detalle de Items -->
            <div id="paso3" class="paso-form" style="display: none;">
              <h4 style="margin-bottom: 1rem;">Paso 3: Confirmar Items y Precios</h4>
              <div id="itemsContainer">
                <!-- Items cargados desde requisición -->
              </div>
              <div style="margin-top: 1.5rem; padding: 1rem; background: #e9ecef; border-radius: 8px;">
                <div style="display: flex; justify-content: space-between; align-items: center;">
                  <span style="font-size: 1.2rem; font-weight: bold;">Total Orden:</span>
                  <span id="totalOrden" style="font-size: 1.5rem; font-weight: bold; color: #007bff;">$0.00</span>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="display: flex; justify-content: space-between;">
            <button type="button" class="btn btn-secondary" id="btnAnterior" onclick="window.ordenesCompraView.pasoAnterior()" style="display: none;">
              ← Anterior
            </button>
            <div></div>
            <div style="display: flex; gap: 0.5rem;">
              <button type="button" class="btn btn-secondary" onclick="window.ordenesCompraView.cerrarModal()">Cancelar</button>
              <button type="button" class="btn btn-primary" id="btnSiguiente" onclick="window.ordenesCompraView.pasoSiguiente()">
                Siguiente →
              </button>
              <button type="button" class="btn btn-success" id="btnGuardar" onclick="window.ordenesCompraView.guardarOrden()" style="display: none;">
                💾 Crear Orden
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal Ver Detalle -->
      <div id="modalDetalle" class="modal" style="display: none;">
        <div class="modal-content" style="max-width: 800px;">
          <div class="modal-header">
            <h3>Detalle de Orden de Compra</h3>
            <button class="modal-close" onclick="window.ordenesCompraView.cerrarModalDetalle()">&times;</button>
          </div>
          <div class="modal-body" id="detalleContent">
            <!-- Contenido dinámico -->
          </div>
          <div class="modal-footer" id="detalleActions">
            <!-- Botones según estado -->
          </div>
        </div>
      </div>

      <style>
        .oc-form-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1rem;
        }
        .oc-info-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 0.75rem;
        }
        .oc-item-card {
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          overflow: hidden;
          margin-bottom: 0.5rem;
        }
        .oc-item-header {
          background: #f8f9fa;
          padding: 0.75rem 1rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          flex-wrap: wrap;
        }
        .oc-item-body {
          padding: 0.75rem 1rem;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 0.5rem;
          font-size: 0.9rem;
        }
        .oc-item-edit-grid {
          padding: 0.75rem 1rem;
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 0.75rem;
          align-items: end;
        }
        @media (max-width: 480px) {
          .oc-form-grid {
            grid-template-columns: 1fr;
          }
          .oc-info-grid {
            grid-template-columns: 1fr;
          }
          .oc-item-body {
            grid-template-columns: 1fr;
          }
          .oc-item-edit-grid {
            grid-template-columns: 1fr 1fr;
          }
        }
      </style>
    `;
  },

  async afterRender() {
    window.ordenesCompraView = this;
    this.paginaActual = 1;
    this.limite = 10;
    this.pasoActual = 1;
    this.requisicionSeleccionada = null;
    this.itemsOrden = [];

    // Verificar si viene de una requisición
    const urlParams = new URLSearchParams(window.location.search);
    const requisicionId = urlParams.get('requisicion');

    // Cargar datos iniciales
    await this.cargarEstadisticas();
    await this.cargarOrdenes();
    await this.cargarProveedores();
    await this.cargarAlmacenes();

    // Event listeners
    document.getElementById('filtroEstado').addEventListener('change', () => this.cargarOrdenes());
    document.getElementById('filtroProveedor').addEventListener('change', () => this.cargarOrdenes());

    document.getElementById('requisicionSelect').addEventListener('change', (e) => {
      this.cargarDetalleRequisicion(e.target.value);
    });

    // Si viene con requisición, abrir modal automáticamente
    if (requisicionId) {
      await this.mostrarModalCrear();
      await this.cargarRequisicionesAprobadas();
      document.getElementById('requisicionSelect').value = requisicionId;
      await this.cargarDetalleRequisicion(requisicionId);
    }
  },

  async cargarEstadisticas() {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await fetch(`${window.API_BASE_URL}/ordenes-compra/estadisticas`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.ok) {
        const result = await response.json();
        const stats = result.data?.estadisticas || {};

        document.getElementById('statEmitida').textContent = stats.emitida || 0;
        document.getElementById('statConfirmada').textContent = stats.confirmada || 0;
        document.getElementById('statEnTransito').textContent = stats.en_transito || 0;
        document.getElementById('statRecibida').textContent = stats.recibida || 0;
      }
    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
    }
  },

  async cargarOrdenes() {
    try {
      const token = localStorage.getItem('accessToken');
      const estado = document.getElementById('filtroEstado').value;
      const proveedor = document.getElementById('filtroProveedor').value;
      const busqueda = document.getElementById('filtroBusqueda').value;

      let url = `${window.API_BASE_URL}/ordenes-compra?pagina=${this.paginaActual}&limite=${this.limite}`;
      if (estado) url += `&estado=${estado}`;
      if (proveedor) url += `&proveedor_id=${proveedor}`;
      if (busqueda) url += `&folio=${encodeURIComponent(busqueda)}`;

      const response = await fetch(url, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) throw new Error('Error al cargar órdenes');

      const result = await response.json();
      this.renderTabla(result.data);

    } catch (error) {
      console.error('Error:', error);
      document.getElementById('ordenesTableBody').innerHTML = `
        <tr><td colspan="9" style="text-align: center; color: red;">Error al cargar órdenes de compra</td></tr>
      `;
    }
  },

  renderTabla(data) {
    const tbody = document.getElementById('ordenesTableBody');
    const ordenes = data.ordenes || [];

    if (ordenes.length === 0) {
      tbody.innerHTML = '<tr><td colspan="9" style="text-align: center;">No hay órdenes de compra</td></tr>';
      return;
    }

    tbody.innerHTML = ordenes.map(oc => {
      const estadoHtml = this.renderEstado(oc.estado);
      const accionesHtml = `
        <button class="btn btn-sm btn-info" onclick="window.ordenesCompraView.verDetalle(${oc.id})" title="Ver">👁️</button>
        ${oc.estado === 'emitida' ? `
          <button class="btn btn-sm btn-success" onclick="window.ordenesCompraView.cambiarEstado(${oc.id}, 'confirmada')" title="Confirmar">✅</button>
          <button class="btn btn-sm btn-danger" onclick="window.ordenesCompraView.eliminar(${oc.id})" title="Eliminar">🗑️</button>
        ` : ''}
        ${oc.estado === 'confirmada' ? `
          <button class="btn btn-sm btn-primary" onclick="window.ordenesCompraView.cambiarEstado(${oc.id}, 'en_transito')" title="En Tránsito">🚚</button>
          <button class="btn btn-sm btn-danger" onclick="window.ordenesCompraView.cambiarEstado(${oc.id}, 'cancelada')" title="Cancelar">❌</button>
        ` : ''}
        ${oc.estado === 'en_transito' ? `
          <button class="btn btn-sm btn-success" onclick="window.ordenesCompraView.cambiarEstado(${oc.id}, 'recibida')" title="Recibida">📦</button>
        ` : ''}
        ${oc.estado === 'recibida' ? `
          <button class="btn btn-sm btn-primary" onclick="window.ordenesCompraView.irACompra(${oc.id})" title="Compra Final">🛒</button>
        ` : ''}
      `;
      return `
      <tr>
        <td><button class="tbl-expand-btn" onclick="window.ordenesCompraView.toggleRow(${oc.id})">&#9654;</button></td>
        <td><strong>${oc.folio}</strong></td>
        <td class="tbl-hide-mobile">${this.formatDate(oc.fecha_orden)}</td>
        <td class="tbl-hide-mobile">${oc.proveedor_nombre || '-'}</td>
        <td class="tbl-hide-mobile">
          ${oc.requisicion_folio ? `<span class="badge" style="background: #6c757d; color: #fff;">${oc.requisicion_folio}</span>` : '-'}
        </td>
        <td class="tbl-hide-mobile" style="text-align: center;">${oc.cantidad_items || 0}</td>
        <td class="tbl-hide-mobile"><strong>$${this.formatNumber(oc.total)} ${oc.moneda || 'USD'}</strong></td>
        <td class="tbl-hide-mobile">${estadoHtml}</td>
        <td class="tbl-hide-mobile">
          <div style="display: flex; gap: 0.25rem; flex-wrap: wrap;">${accionesHtml}</div>
        </td>
      </tr>
      <tr class="tbl-detail-row" id="detail-oc-${oc.id}">
        <td colspan="9" class="tbl-detail-cell">
          <dl class="tbl-detail-grid">
            <dt>Fecha</dt><dd>${this.formatDate(oc.fecha_orden)}</dd>
            <dt>Proveedor</dt><dd>${oc.proveedor_nombre || '-'}</dd>
            <dt>Requisición</dt><dd>${oc.requisicion_folio || '-'}</dd>
            <dt>Items</dt><dd>${oc.cantidad_items || 0}</dd>
            <dt>Total</dt><dd>$${this.formatNumber(oc.total)} ${oc.moneda || 'USD'}</dd>
            <dt>Estado</dt><dd>${estadoHtml}</dd>
          </dl>
          <div style="margin-top: var(--spacing-sm); display: flex; gap: var(--spacing-xs); flex-wrap: wrap;">${accionesHtml}</div>
        </td>
      </tr>
    `}).join('');
  },

  toggleRow(id) {
    const detailRow = document.getElementById(`detail-oc-${id}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  toggleReqRow(idx) {
    const detailRow = document.getElementById(`detail-ocreq-${idx}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  toggleDetRow(idx) {
    const detailRow = document.getElementById(`detail-ocdet-${idx}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  async cargarProveedores() {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await fetch(`${window.API_BASE_URL}/personas/rol/proveedor`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.ok) {
        const result = await response.json();
        const proveedores = result.data?.personas || [];

        // Filtro
        const filtroSelect = document.getElementById('filtroProveedor');
        proveedores.forEach(p => {
          const option = document.createElement('option');
          option.value = p.id;
          option.textContent = p.nombre_comercial || p.nombre_completo;
          filtroSelect.appendChild(option);
        });

        // Select del modal
        const modalSelect = document.getElementById('proveedorSelect');
        proveedores.forEach(p => {
          const option = document.createElement('option');
          option.value = p.id;
          option.textContent = p.nombre_comercial || p.nombre_completo;
          modalSelect.appendChild(option);
        });
      }
    } catch (error) {
      console.error('Error al cargar proveedores:', error);
    }
  },

  async cargarAlmacenes() {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await fetch(`${window.API_BASE_URL}/almacenes/activos`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.ok) {
        const result = await response.json();
        this.almacenes = result.data?.almacenes || [];

        const almacenSelect = document.getElementById('almacenSelect');
        this.almacenes.forEach(a => {
          const option = document.createElement('option');
          option.value = a.id;
          option.textContent = `${a.codigo} - ${a.nombre}${a.ubicacion ? ' (' + a.ubicacion + ')' : ''}`;
          almacenSelect.appendChild(option);
        });
      }
    } catch (error) {
      console.error('Error al cargar almacenes:', error);
    }
  },

  async mostrarModalCrear() {
    this.pasoActual = 1;
    this.requisicionSeleccionada = null;
    this.itemsOrden = [];
    this.actualizarPasos();
    await this.cargarRequisicionesAprobadas();
    document.getElementById('modalCrearOC').style.display = 'flex';
  },

  cerrarModal() {
    document.getElementById('modalCrearOC').style.display = 'none';
    document.getElementById('requisicionSelect').value = '';
    document.getElementById('requisicionDetalle').style.display = 'none';
    document.getElementById('proveedorSelect').value = '';
    document.getElementById('almacenSelect').value = '';
    document.getElementById('observaciones').value = '';
    this.pasoActual = 1;
    this.actualizarPasos();
  },

  async cargarRequisicionesAprobadas() {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await fetch(`${window.API_BASE_URL}/requisiciones?estado=aprobada&limit=100`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.ok) {
        const result = await response.json();
        const requisiciones = result.data?.requisiciones || [];

        const select = document.getElementById('requisicionSelect');
        select.innerHTML = '<option value="">Seleccione una requisición...</option>';

        requisiciones.forEach(r => {
          const option = document.createElement('option');
          option.value = r.id;
          option.textContent = `${r.folio} - ${this.formatTipoOrigen(r.tipo_origen)} - ${r.cantidad_items || 0} items`;
          select.appendChild(option);
        });
      }
    } catch (error) {
      console.error('Error al cargar requisiciones:', error);
    }
  },

  async cargarDetalleRequisicion(id) {
    if (!id) {
      document.getElementById('requisicionDetalle').style.display = 'none';
      this.requisicionSeleccionada = null;
      return;
    }

    try {
      const token = localStorage.getItem('accessToken');
      const response = await fetch(`${window.API_BASE_URL}/requisiciones/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) throw new Error('Error al cargar detalle');

      const result = await response.json();
      this.requisicionSeleccionada = result.data?.requisicion;

      document.getElementById('requisicionDetalle').style.display = 'block';
      document.getElementById('requisicionDetalle').innerHTML = `
        <div class="oc-info-grid" style="margin-bottom: 1rem;">
          <div><strong>Folio:</strong> ${this.requisicionSeleccionada.folio}</div>
          <div><strong>Prioridad:</strong> ${this.renderPrioridad(this.requisicionSeleccionada.prioridad)}</div>
          <div><strong>Tipo:</strong> ${this.formatTipoOrigen(this.requisicionSeleccionada.tipo_origen)}</div>
          <div><strong>Fecha Requerida:</strong> ${this.requisicionSeleccionada.fecha_requerida ? this.formatDate(this.requisicionSeleccionada.fecha_requerida) : 'No especificada'}</div>
        </div>
        <h5>Tractores Solicitados:</h5>
        <table class="table" style="font-size: 0.9rem;">
          <thead>
            <tr>
              <th></th>
              <th>Marca</th>
              <th class="tbl-hide-mobile">Modelo</th>
              <th class="tbl-hide-mobile">Año</th>
              <th class="tbl-hide-mobile">Cant.</th>
              <th class="tbl-hide-mobile">Costo Est.</th>
            </tr>
          </thead>
          <tbody>
            ${(this.requisicionSeleccionada.detalles || []).map((d, idx) => `
              <tr>
                <td><button class="tbl-expand-btn" onclick="window.ordenesCompraView.toggleReqRow(${idx})">&#9654;</button></td>
                <td><strong>${d.marca}</strong></td>
                <td class="tbl-hide-mobile">${d.modelo}</td>
                <td class="tbl-hide-mobile">${d.anio || '-'}</td>
                <td class="tbl-hide-mobile">${d.cantidad}</td>
                <td class="tbl-hide-mobile">${d.costo_estimado_unitario ? '$' + this.formatNumber(d.costo_estimado_unitario) : '-'}</td>
              </tr>
              <tr class="tbl-detail-row" id="detail-ocreq-${idx}">
                <td colspan="6" class="tbl-detail-cell">
                  <dl class="tbl-detail-grid">
                    <dt>Modelo</dt><dd>${d.modelo}</dd>
                    <dt>Año</dt><dd>${d.anio || '-'}</dd>
                    <dt>Cantidad</dt><dd>${d.cantidad}</dd>
                    <dt>Costo Est.</dt><dd>${d.costo_estimado_unitario ? '$' + this.formatNumber(d.costo_estimado_unitario) : '-'}</dd>
                  </dl>
                </td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      `;

      // Preparar items para el paso 3
      this.itemsOrden = (this.requisicionSeleccionada.detalles || []).map(d => ({
        requisicion_detalle_id: d.id,
        marca: d.marca,
        modelo: d.modelo,
        anio: d.anio,
        cantidad: d.cantidad,
        precio_unitario: d.costo_estimado_unitario || 0,
        subtotal: (d.costo_estimado_unitario || 0) * d.cantidad
      }));

    } catch (error) {
      console.error('Error:', error);
      this.mostrarAlerta('Error al cargar detalle de requisición', 'error');
    }
  },

  actualizarPasos() {
    document.querySelectorAll('.paso-form').forEach((el, idx) => {
      el.style.display = (idx + 1 === this.pasoActual) ? 'block' : 'none';
    });

    document.getElementById('btnAnterior').style.display = this.pasoActual > 1 ? 'block' : 'none';
    document.getElementById('btnSiguiente').style.display = this.pasoActual < 3 ? 'block' : 'none';
    document.getElementById('btnGuardar').style.display = this.pasoActual === 3 ? 'block' : 'none';
  },

  pasoAnterior() {
    if (this.pasoActual > 1) {
      this.pasoActual--;
      this.actualizarPasos();
    }
  },

  pasoSiguiente() {
    if (this.pasoActual === 1) {
      if (!this.requisicionSeleccionada) {
        this.mostrarAlerta('Debe seleccionar una requisición', 'error');
        return;
      }
    }

    if (this.pasoActual === 2) {
      if (!document.getElementById('proveedorSelect').value) {
        this.mostrarAlerta('Debe seleccionar un proveedor', 'error');
        return;
      }
      // Renderizar items
      this.renderItemsOrden();
    }

    if (this.pasoActual < 3) {
      this.pasoActual++;
      this.actualizarPasos();
    }
  },

  renderItemsOrden() {
    const container = document.getElementById('itemsContainer');
    const moneda = document.getElementById('moneda').value;

    container.innerHTML = this.itemsOrden.map((item, idx) => `
      <div class="item-orden oc-item-card">
        <div class="oc-item-header">
          <strong>${item.marca} ${item.modelo}</strong>
          ${item.anio ? `<span style="color: #666;">(${item.anio})</span>` : ''}
        </div>
        <div class="oc-item-edit-grid">
          <div class="form-group" style="margin-bottom: 0;">
            <label class="form-label" style="font-size: 0.85rem;">Cantidad</label>
            <input type="number" class="form-input" value="${item.cantidad}" min="1"
              onchange="window.ordenesCompraView.actualizarItem(${idx}, 'cantidad', this.value)" />
          </div>
          <div class="form-group" style="margin-bottom: 0;">
            <label class="form-label" style="font-size: 0.85rem;">Precio Unit. (${moneda})</label>
            <input type="number" class="form-input" value="${item.precio_unitario}" step="0.01" min="0"
              onchange="window.ordenesCompraView.actualizarItem(${idx}, 'precio_unitario', this.value)" />
          </div>
          <div style="text-align: right;">
            <label class="form-label" style="font-size: 0.85rem;">Subtotal</label>
            <div style="font-weight: bold; color: #007bff;">$${this.formatNumber(item.subtotal)}</div>
          </div>
        </div>
      </div>
    `).join('');

    this.calcularTotal();
  },

  actualizarItem(index, campo, valor) {
    this.itemsOrden[index][campo] = parseFloat(valor) || 0;
    this.itemsOrden[index].subtotal = this.itemsOrden[index].cantidad * this.itemsOrden[index].precio_unitario;

    // Actualizar subtotal en UI
    const container = document.getElementById('itemsContainer');
    const items = container.querySelectorAll('.item-orden');
    if (items[index]) {
      const subtotalEl = items[index].querySelector('div[style*="text-align: right"] div');
      if (subtotalEl) {
        subtotalEl.textContent = '$' + this.formatNumber(this.itemsOrden[index].subtotal);
      }
    }

    this.calcularTotal();
  },

  calcularTotal() {
    const total = this.itemsOrden.reduce((sum, item) => sum + (item.subtotal || 0), 0);
    const moneda = document.getElementById('moneda').value;
    document.getElementById('totalOrden').textContent = `$${this.formatNumber(total)} ${moneda}`;
  },

  async guardarOrden() {
    try {
      const token = localStorage.getItem('accessToken');

      const almacenId = document.getElementById('almacenSelect').value;
      let lugarEntrega = null;

      if (almacenId) {
        const almacen = this.almacenes?.find(a => a.id === parseInt(almacenId));
        if (almacen) {
          lugarEntrega = `${almacen.codigo} - ${almacen.nombre}${almacen.ubicacion ? ' (' + almacen.ubicacion + ')' : ''}`;
        }
      }

      const data = {
        requisicion_id: this.requisicionSeleccionada.id,
        proveedor_id: parseInt(document.getElementById('proveedorSelect').value),
        moneda: document.getElementById('moneda').value,
        fecha_entrega_esperada: document.getElementById('fechaEntrega').value || null,
        condiciones_pago: document.getElementById('condicionesPago').value,
        lugar_entrega: lugarEntrega,
        observaciones: document.getElementById('observaciones').value || null,
        detalles: this.itemsOrden.map(item => ({
          requisicion_detalle_id: item.requisicion_detalle_id,
          marca: item.marca,
          modelo: item.modelo,
          anio: item.anio,
          cantidad: item.cantidad,
          precio_unitario: item.precio_unitario
        }))
      };

      const response = await fetch(`${window.API_BASE_URL}/ordenes-compra`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error?.message || result.message || 'Error al crear orden');
      }

      this.mostrarAlerta('Orden de compra creada exitosamente', 'success');
      this.cerrarModal();
      await this.cargarEstadisticas();
      await this.cargarOrdenes();

      // Limpiar parámetros URL si existe
      if (window.location.search) {
        window.history.replaceState({}, '', window.location.pathname);
      }

    } catch (error) {
      console.error('Error:', error);
      this.mostrarAlerta(error.message, 'error');
    }
  },

  async verDetalle(id) {
    try {
      const token = localStorage.getItem('accessToken');
      const response = await fetch(`${window.API_BASE_URL}/ordenes-compra/${id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) throw new Error('Error al cargar detalle');

      const result = await response.json();
      const oc = result.data?.orden;

      document.getElementById('detalleContent').innerHTML = `
        <div style="display: grid; gap: 1rem;">
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
            <div><strong>Folio:</strong> ${oc.folio}</div>
            <div><strong>Estado:</strong> ${this.renderEstado(oc.estado)}</div>
            <div><strong>Fecha:</strong> ${this.formatDate(oc.fecha_orden)}</div>
            <div><strong>Proveedor:</strong> ${oc.proveedor_nombre || '-'}</div>
            <div><strong>Requisición:</strong> ${oc.requisicion_folio || '-'}</div>
            <div><strong>Condiciones Pago:</strong> ${this.formatCondicionesPago(oc.condiciones_pago)}</div>
            <div><strong>Fecha Entrega Esperada:</strong> ${oc.fecha_entrega_esperada ? this.formatDate(oc.fecha_entrega_esperada) : 'No especificada'}</div>
            <div><strong>Lugar de Entrega:</strong> ${oc.lugar_entrega || 'No especificado'}</div>
            <div><strong>Moneda:</strong> ${oc.moneda}</div>
          </div>

          <hr style="margin: 1rem 0;" />

          <h4>Detalle de Items</h4>
          <table class="table" style="font-size: 0.9rem;">
            <thead>
              <tr>
                <th></th>
                <th>Descripción</th>
                <th class="tbl-hide-mobile">Cant.</th>
                <th class="tbl-hide-mobile">P. Unit.</th>
                <th class="tbl-hide-mobile">Subtotal</th>
              </tr>
            </thead>
            <tbody>
              ${(oc.detalles || []).map((d, idx) => `
                <tr>
                  <td><button class="tbl-expand-btn" onclick="window.ordenesCompraView.toggleDetRow(${idx})">&#9654;</button></td>
                  <td><strong>${d.marca || ''} ${d.modelo || ''} ${d.anio ? '(' + d.anio + ')' : ''}</strong></td>
                  <td class="tbl-hide-mobile">${d.cantidad}</td>
                  <td class="tbl-hide-mobile">$${this.formatNumber(d.precio_unitario)}</td>
                  <td class="tbl-hide-mobile"><strong>$${this.formatNumber(d.subtotal)}</strong></td>
                </tr>
                <tr class="tbl-detail-row" id="detail-ocdet-${idx}">
                  <td colspan="5" class="tbl-detail-cell">
                    <dl class="tbl-detail-grid">
                      <dt>Cantidad</dt><dd>${d.cantidad}</dd>
                      <dt>P. Unit.</dt><dd>$${this.formatNumber(d.precio_unitario)}</dd>
                      <dt>Subtotal</dt><dd><strong style="color: #007bff;">$${this.formatNumber(d.subtotal)}</strong></dd>
                    </dl>
                  </td>
                </tr>
              `).join('')}
            </tbody>
            <tfoot>
              <tr>
                <td colspan="4" style="text-align: right;"><strong>Total:</strong></td>
                <td><strong style="color: #007bff; font-size: 1.1rem;">$${this.formatNumber(oc.total)} ${oc.moneda}</strong></td>
              </tr>
            </tfoot>
          </table>

          ${oc.observaciones ? `<div><strong>Observaciones:</strong> ${oc.observaciones}</div>` : ''}
        </div>
      `;

      // Acciones según estado
      let actions = '<button class="btn btn-secondary" onclick="window.ordenesCompraView.cerrarModalDetalle()">Cerrar</button>';

      if (oc.estado === 'confirmada') {
        actions = `
          <button class="btn btn-secondary" onclick="window.ordenesCompraView.cerrarModalDetalle()">Cerrar</button>
          <button class="btn btn-primary" onclick="window.ordenesCompraView.irACompra(${oc.id})">🛒 Crear Compra Final</button>
        `;
      }

      document.getElementById('detalleActions').innerHTML = actions;
      document.getElementById('modalDetalle').style.display = 'flex';

    } catch (error) {
      console.error('Error:', error);
      this.mostrarAlerta('Error al cargar detalle', 'error');
    }
  },

  cerrarModalDetalle() {
    document.getElementById('modalDetalle').style.display = 'none';
  },

  async cambiarEstado(id, nuevoEstado) {
    const mensajes = {
      'confirmada': '¿Confirmar esta orden de compra? El proveedor ha aceptado la orden.',
      'en_transito': '¿Marcar esta orden como En Tránsito? Los productos están en camino.',
      'recibida': '¿Marcar esta orden como Recibida? Los productos llegaron al almacén.',
      'cancelada': '¿Cancelar esta orden de compra?'
    };

    modal.confirm(
      'Cambiar estado de la orden',
      mensajes[nuevoEstado] || `¿Cambiar estado a ${nuevoEstado}?`,
      async () => {
        try {
          const token = localStorage.getItem('accessToken');
          const response = await fetch(`${window.API_BASE_URL}/ordenes-compra/${id}/estado`, {
            method: 'PATCH',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ estado: nuevoEstado })
          });

          if (!response.ok) {
            const result = await response.json();
            throw new Error(result.message || 'Error al cambiar estado');
          }

          this.mostrarAlerta(`Orden ${nuevoEstado} exitosamente`, 'success');
          await this.cargarEstadisticas();
          await this.cargarOrdenes();

        } catch (error) {
          console.error('Error:', error);
          this.mostrarAlerta(error.message, 'error');
        }
      }
    );
  },

  async eliminar(id) {
    modal.confirm(
      'Confirmar eliminación',
      `¿Está seguro de eliminar la <strong>orden de compra #${id}</strong>? Esta acción no se puede deshacer.`,
      async () => {
        try {
          const token = localStorage.getItem('accessToken');
          const response = await fetch(`${window.API_BASE_URL}/ordenes-compra/${id}`, {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${token}` }
          });

          if (!response.ok) {
            const result = await response.json();
            throw new Error(result.message || 'Error al eliminar');
          }

          this.mostrarAlerta('Orden eliminada exitosamente', 'success');
          await this.cargarEstadisticas();
          await this.cargarOrdenes();

        } catch (error) {
          console.error('Error:', error);
          this.mostrarAlerta(error.message, 'error');
        }
      }
    );
  },

  irACompra(ordenId) {
    this.cerrarModalDetalle();
    router.navigate(`/compras/nueva?orden=${ordenId}`);
  },

  renderEstado(estado) {
    const estados = {
      'emitida': '<span class="badge" style="background: #ffc107; color: #000;">Emitida</span>',
      'confirmada': '<span class="badge" style="background: #28a745; color: #fff;">Confirmada</span>',
      'en_transito': '<span class="badge" style="background: #17a2b8; color: #fff;">En Tránsito</span>',
      'recibida': '<span class="badge" style="background: #007bff; color: #fff;">Recibida</span>',
      'cancelada': '<span class="badge" style="background: #dc3545; color: #fff;">Cancelada</span>'
    };
    return estados[estado] || estado;
  },

  renderPrioridad(prioridad) {
    const prioridades = {
      'urgente': '<span style="color: #dc3545; font-weight: bold;">🔴 Urgente</span>',
      'alta': '<span style="color: #fd7e14;">🟠 Alta</span>',
      'media': '<span style="color: #ffc107;">🟡 Media</span>',
      'baja': '<span style="color: #28a745;">🟢 Baja</span>'
    };
    return prioridades[prioridad] || prioridad;
  },

  formatTipoOrigen(tipo) {
    return tipo === 'distribuidor' ? '👤 Distribuidor' : '📦 Stock Almacén';
  },

  formatCondicionesPago(condicion) {
    const condiciones = {
      'contado': 'Contado',
      'credito_30': 'Crédito 30 días',
      'credito_60': 'Crédito 60 días',
      'credito_90': 'Crédito 90 días',
      'anticipo_50': '50% Anticipo'
    };
    return condiciones[condicion] || condicion;
  },

  formatDate(dateString) {
    if (!dateString) return '-';
    return new Date(dateString).toLocaleDateString('es-MX', {
      year: 'numeric', month: 'short', day: 'numeric'
    });
  },

  formatNumber(num) {
    return parseFloat(num || 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  },

  mostrarAlerta(mensaje, tipo = 'info') {
    const div = document.createElement('div');
    div.style.cssText = `
      position: fixed; top: 20px; right: 20px; z-index: 9999;
      padding: 1rem 1.5rem; border-radius: 4px; color: white;
      background: ${tipo === 'success' ? '#28a745' : tipo === 'error' ? '#dc3545' : '#007bff'};
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    `;
    div.textContent = mensaje;
    document.body.appendChild(div);
    setTimeout(() => div.remove(), 3000);
  }
};
